import React, {Component} from "react";
import "./Icon.css";

import {joinClasses} from "utils";

export default class Icon extends Component
{
	render()
	{
		const name = "icon-" + this.props.children;
		const classes = joinClasses(
		[
			"tooltip",
			(this.props.titleBottom && "tooltip-bottom"),
		]);

		return (
			<div className="icon-container">
				<svg className={"svgIcon " + name}>
					<use xlinkHref={"#" + name}></use>
				</svg>

				{this.props.title &&
					<div className={classes}>
						{this.props.title}
					</div>
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js